import { useContext, useEffect, useState } from 'react';

import { TimerProviderContext } from '@swf/core/providers/TimerProvider';

interface TimerOptions {
  initial?: number;
  modifier?(count: number): number;
}

type Timer = (options: TimerOptions) => number;

const useTimer: Timer = ({ modifier, initial = 0 }) => {
  const [count, setCount] = useState(initial);
  const { counter } = useContext(TimerProviderContext);

  useEffect(() => {
    const subscription = counter.subscribe((x) => setCount(modifier || initial + x));

    return () => subscription.unsubscribe();
  }, [modifier, counter, initial]);

  return count;
};

export default useTimer;
